export default __webpack_public_path__ + "static/media/icon-send-round.381b6917.svg";